(function () {
  'use strict';


  function initHiChanCarousel(carousel) {

    if (
      carousel.getAttribute(
        'data-hichan-carousel-ready'
      ) === 'true'
    ) {
      return;
    }


    const viewport =
      carousel.querySelector(
        '.hichan-carousel-viewport'
      );


    const track =
      carousel.querySelector(
        '.hichan-carousel-track'
      );


    const slides =
      Array.from(
        carousel.querySelectorAll(
          '.hichan-carousel-slide'
        )
      );


    if (
      !viewport ||
      !track ||
      slides.length < 2
    ) {
      return;
    }


    carousel.setAttribute(
      'data-hichan-carousel-ready',
      'true'
    );


    /*
      ==================================================
      STATE
      ==================================================
    */

    let hintStopped = false;

    let activeIndex = 0;

    let mouseDown = false;

    let mouseDragging = false;

    let mouseStartX = 0;

    let mouseStartY = 0;

    let mouseStartScrollLeft = 0;

    let mouseStartIndex = 0;

    let suppressNextClick = false;

    let resizeTimer = null;



    /*
      ==================================================
      HELPERS
      ==================================================
    */

    function clampIndex(index) {

      return Math.max(
        0,
        Math.min(
          slides.length - 1,
          index
        )
      );

    }


    /*
      IMPORTANT:

      We use the actual position of every slide.

      No width multiplication.
      No assumptions about Grid/Flex geometry.
    */

    function slidePosition(index) {

      const slide =
        slides[
          clampIndex(index)
        ];


      return slide.offsetLeft;

    }


    function getCurrentIndex() {

      const currentScroll =
        viewport.scrollLeft;


      let closestIndex = 0;

      let closestDistance =
        Infinity;


      slides.forEach(
        function (slide, index) {

          const distance =
            Math.abs(
              slide.offsetLeft -
              currentScroll
            );


          if (
            distance <
            closestDistance
          ) {

            closestDistance =
              distance;


            closestIndex =
              index;

          }

        }
      );


      return closestIndex;

    }



    /*
      ==================================================
      INITIAL BOUNCE
      ==================================================
    */

    function stopHint() {

      if (hintStopped) {
        return;
      }


      hintStopped = true;


      carousel.classList.remove(
        'is-hinting'
      );


      /*
        Reset the track immediately in case the visitor
        interacts halfway through the animation.
      */

      track.style.animation =
        'none';


      track.style.transform =
        'translate3d(0,0,0)';

    }



    /*
      ==================================================
      NAVIGATION
      ==================================================
    */

    function goToSlide(
      index,
      behavior
    ) {

      stopHint();


      activeIndex =
        clampIndex(index);


      viewport.scrollTo({

        left:
          slidePosition(
            activeIndex
          ),

        top: 0,

        behavior:
          behavior || 'smooth'

      });

    }


    function nextSlide() {

      const current =
        getCurrentIndex();


      if (
        current <
        slides.length - 1
      ) {

        goToSlide(
          current + 1,
          'smooth'
        );

      }

    }


    function previousSlide() {

      const current =
        getCurrentIndex();


      if (
        current > 0
      ) {

        goToSlide(
          current - 1,
          'smooth'
        );

      }

    }



    /*
      ==================================================
      DESKTOP CLICK

      THIS is now independent from mouse-drag handling.

      Normal click anywhere on the manga:
      advance exactly one page.
      ==================================================
    */

    viewport.addEventListener(
      'click',
      function (event) {

        /*
          Ignore the synthetic click generated
          immediately after a mouse drag.
        */

        if (
          suppressNextClick
        ) {

          suppressNextClick =
            false;


          event.preventDefault();


          return;

        }


        /*
          Only desktop-like pointers get
          click-to-next behavior.

          Touch devices keep normal native swiping.
        */

        if (
          window.matchMedia(
            '(hover: hover) and (pointer: fine)'
          ).matches
        ) {

          event.preventDefault();


          nextSlide();

        }

      }
    );



    /*
      ==================================================
      DESKTOP MOUSE DRAG START

      This uses old-school mouse events deliberately.

      They are extremely predictable on desktop browsers.
      ==================================================
    */

    viewport.addEventListener(
      'mousedown',
      function (event) {

        /*
          Left mouse button only.
        */

        if (
          event.button !== 0
        ) {
          return;
        }


        stopHint();


        mouseDown = true;


        mouseDragging =
          false;


        mouseStartX =
          event.clientX;


        mouseStartY =
          event.clientY;


        mouseStartScrollLeft =
          viewport.scrollLeft;


        mouseStartIndex =
          getCurrentIndex();

      }
    );



    /*
      ==================================================
      DESKTOP MOUSE DRAG MOVE
      ==================================================
    */

    window.addEventListener(
      'mousemove',
      function (event) {

        if (
          !mouseDown
        ) {
          return;
        }


        const dx =
          event.clientX -
          mouseStartX;


        const dy =
          event.clientY -
          mouseStartY;


        /*
          Do not enter drag mode until the visitor
          actually moves horizontally.
        */

        if (
          !mouseDragging &&
          Math.abs(dx) > 7 &&
          Math.abs(dx) >
            Math.abs(dy)
        ) {

          mouseDragging =
            true;


          viewport.classList.add(
            'is-dragging'
          );

        }


        if (
          !mouseDragging
        ) {
          return;
        }


        event.preventDefault();


        viewport.scrollLeft =
          mouseStartScrollLeft -
          dx;

      },
      {
        passive: false
      }
    );



    /*
      ==================================================
      DESKTOP MOUSE DRAG END
      ==================================================
    */

    window.addEventListener(
      'mouseup',
      function (event) {

        if (
          !mouseDown
        ) {
          return;
        }


        const dx =
          event.clientX -
          mouseStartX;


        const dy =
          event.clientY -
          mouseStartY;


        const wasDragging =
          mouseDragging;


        mouseDown =
          false;


        mouseDragging =
          false;


        viewport.classList.remove(
          'is-dragging'
        );


        /*
          A real drag should NOT subsequently
          trigger click-to-next.
        */

        if (
          wasDragging
        ) {

          suppressNextClick =
            true;


          const threshold =
            Math.max(
              42,
              viewport.clientWidth *
                0.08
            );


          let destination =
            mouseStartIndex;


          /*
            Drag left:
            next manga page.
          */

          if (
            dx <
              -threshold &&
            Math.abs(dx) >
              Math.abs(dy)
          ) {

            destination =
              mouseStartIndex + 1;

          }


          /*
            Drag right:
            previous manga page.
          */

          else if (
            dx >
              threshold &&
            Math.abs(dx) >
              Math.abs(dy)
          ) {

            destination =
              mouseStartIndex - 1;

          }


          /*
            Small drag:
            snap to whichever page is closest.
          */

          else {

            destination =
              getCurrentIndex();

          }


          goToSlide(
            destination,
            'smooth'
          );


          /*
            Browser click comes immediately after
            mouseup. Clear the suppression just after it.
          */

          window.setTimeout(
            function () {

              suppressNextClick =
                false;

            },
            50
          );

        }

      }
    );



    /*
      ==================================================
      MOBILE / TABLET

      Native browser touch scrolling.
      ==================================================
    */

    viewport.addEventListener(
      'touchstart',
      function () {

        stopHint();

      },
      {
        passive: true
      }
    );



    /*
      ==================================================
      KEYBOARD
      ==================================================
    */

    viewport.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key ===
          'ArrowRight'
        ) {

          event.preventDefault();


          nextSlide();

        }


        if (
          event.key ===
          'ArrowLeft'
        ) {

          event.preventDefault();


          previousSlide();

        }

      }
    );



    /*
      ==================================================
      NATIVE SCROLL

      Includes:
      - touch swipe
      - Mac trackpad
      - horizontal mouse wheel
      ==================================================
    */

    viewport.addEventListener(
      'scroll',
      function () {

        if (
          Math.abs(
            viewport.scrollLeft
          ) > 2
        ) {

          stopHint();

        }


        if (
          !mouseDragging
        ) {

          activeIndex =
            getCurrentIndex();

        }

      },
      {
        passive: true
      }
    );



    /*
      ==================================================
      RESIZE
      ==================================================
    */

    window.addEventListener(
      'resize',
      function () {

        clearTimeout(
          resizeTimer
        );


        activeIndex =
          getCurrentIndex();


        resizeTimer =
          window.setTimeout(
            function () {

              goToSlide(
                activeIndex,
                'auto'
              );

            },
            150
          );

      }
    );



    /*
      Make sure the browser starts exactly
      at page 1.
    */

    activeIndex =
      getCurrentIndex();

  }



  /*
    ====================================================
    INITIALIZE EVERYTHING
    ====================================================
  */

  function initAllHiChanCarousels() {

    const carousels =
      document.querySelectorAll(
        '.hichan-carousel'
      );


    carousels.forEach(
      initHiChanCarousel
    );

  }



  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllHiChanCarousels,
      {
        once: true
      }
    );

  } else {

    initAllHiChanCarousels();

  }



  /*
    Shopify theme editor reload.
  */

  document.addEventListener(
    'shopify:section:load',
    initAllHiChanCarousels
  );



  /*
    Extra safety in case article content is inserted
    just after the initial page lifecycle.
  */

  window.setTimeout(
    initAllHiChanCarousels,
    500
  );

})();